import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';

class ClosuresOfCashReceiptsExcel {
    exportExcel(data, fecha_inicial, fecha_final) {
        let option = {};  // La opción representa el archivo de Excel
        let closuresOfCashReceipts = this.closuresOfCashReceipts(data, fecha_inicial, fecha_final);
        option.fileName = 'Cierre de Recibos';  // Nombre del archivo Excel
        option.datas = [
            {
                sheetData: closuresOfCashReceipts.data,  // Fuente de datos en archivo Excel
                sheetName: 'Cierre de Recibos',  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel

    }

    closuresOfCashReceipts(dataReceipt, fecha_inicial, fecha_final) {
        let dataTable = [];
        let titulosCierreCaja = this.generarTituloConVacios();//Titulos del Recibo de Caja
        let tituloFechaInicial = this.generarTituloFechaInicial(fecha_inicial);
        let tituloFechaFinal = this.generarTituloFechaFinal(fecha_final);

        dataTable.push(titulosCierreCaja);
        dataTable.push(tituloFechaInicial);
        dataTable.push(tituloFechaFinal);
        let Casillas = this.generarCasillas();
        dataTable.push(Casillas);
        let recibosCaja = dataReceipt.recibos_caja;
        

        for (let i = 0; i < recibosCaja.length; i++) {
            let casillaRecibo = this.generarCasillasRecibo(recibosCaja[i]);
            dataTable.push(casillaRecibo);
        }
        let CasillasVacias = this.generarCasillasVacias();
        dataTable.push(CasillasVacias);



        let sheet =
        {
            data: dataTable
        }
        return sheet;
    }

    generarCasillasVacias() {
        let casillas = {
            '1': "",
            '2': "",
            '3': "",
            '4': "",
            '5': "",
            '6': "",
            '7': "",
            '8': "",
            '9': "",
            '10': "",
            '11': "",
            '12': "",
            '13': "",
            '14':""
        }
        return casillas;
    }

    generarTituloConVacios() {
        let Titulos = {
            '1': 'Tipo de Reporte',
            '2': "Reporte de Recibos de Caja",
        }
        return Titulos;
    }

    generarTituloFechaInicial(fecha_inicial) {
        let Titulos = {
            '1': 'Fecha Inicial',
            '2': moment(fecha_inicial).format('MMMM Do YYYY'),
        }
        return Titulos;
    }

    generarTituloFechaFinal(fecha_final) {
        let Titulos = {
            '1': 'Fecha Final',
            '2': moment(fecha_final).format('MMMM Do YYYY'),
        }
        return Titulos;
    }

    generarCasillas() {
        let casillas = {
            '1': "Tipo de Documento",
            '2': "Número de Documento",
            '3': "Nombre del Paciente",
            '4': "Factura",
            '5': "Fecha Facturación",
            '6': "Fecha recibo",
            '7': "Núm de Recibo",
            '8': "Admisión",
            '9': "Cliente",
            '10': "CUPS",
            '11': "Subtotal",
            '12': "Recibo",
            '13': "Total",
            "14": "Recibo Anulado"
        }
        return casillas;
    }

    generarCasillasRecibo(reciboCaja) {
        let num_recibo = reciboCaja.num_recibo != "" && reciboCaja.num_recibo != null ? reciboCaja.num_recibo : "N/a";
        let serviciosText = "";
        for (let k = 0; k < reciboCaja.cita_servicios.servicios.length; k++) {
            if (k == 0) {
                serviciosText = reciboCaja.cita_servicios.servicios[k].codigo + '-' + reciboCaja.cita_servicios.servicios[k].nombre;
            }
            else {
                serviciosText = serviciosText + ", " + reciboCaja.cita_servicios.servicios[k].codigo + '-' + reciboCaja.cita_servicios.servicios[k].nombre;
            }
        }

        let casillas = {
            '1': reciboCaja.tipo_documento_paciente,
            '2': reciboCaja.num_documento_paciente,
            '3': reciboCaja.nombre_paciente,
            '4': reciboCaja.num_fac_ter,
            '5': reciboCaja.fecha_emision != null && reciboCaja.fecha_emision != undefined ? moment(reciboCaja.fecha_emision).format("DD/MM/YYYY") : "",
            '6': reciboCaja.fecha != null && reciboCaja.fecha != undefined ? moment(reciboCaja.fecha).format("DD/MM/YYYY") : "",
            '7': num_recibo,
            '8': reciboCaja.id_admision,
            '9': reciboCaja.cliente,
            '10': serviciosText,
            '11': parseInt(reciboCaja.valor_tercero) + parseInt(reciboCaja.total),
            '12': parseInt(reciboCaja.total),
            '13': parseInt(reciboCaja.valor_tercero),
            '14': reciboCaja.recibo_cancelado == true ? "SI" : "NO"
        }
        return casillas;
    }

    generarCasillasSubtotal(subtotal) {
        let casillas = {
            '1': "Subtotal",
            '2': "$ " + subtotal
        }
        return casillas;
    }

    generarCasillasCopagoTarjetas(pago_tarjeta) {
        let casillas = {
            '1': "Pagos Tarjeta",
            '2': "$ " + pago_tarjeta
        }
        return casillas;
    }

    generarCasillasCopagoCheques(pago_cheque) {
        let casillas = {
            '1': "Pagos Cheques",
            '2': "$" + pago_cheque
        }
        return casillas;
    }

    generarCasillasCopagoEfectivo(pago_efectivo) {
        let casillas = {
            '1': "Pagos Efectivo",
            '2': "$" + pago_efectivo
        }
        return casillas;
    }

    generarCasillasCopagoTotal(pago_total) {
        let casillas = {
            '1': "Pago Total",
            '2': "$" + pago_total
        }
        return casillas;
    }

    generarCasillasTotalRecibos(total) {
        let casillas = {
            '1': "Pago Total",
            '2': "$" + total
        }
        return casillas;
    }

}

export default new ClosuresOfCashReceiptsExcel();